export enum WORD_RESULT {
	INCORRECT = 0,
	CORRECT = 1,
	SKIP = 2,
}
